import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
const CheckboxChecked = forwardRef(({ ...props }, ref) => {
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-hidden": ariaHidden, ...props, children: [_jsx("rect", { width: 16, height: 16, fill: "#0090e3", className: "CheckboxChecked-rect", rx: 4 }), _jsx("path", { fill: "#fff", d: "M7.719 11.219a1 1 0 0 1-.719.305 1 1 0 0 1-.719-.305L3.313 8.094a1.094 1.094 0 0 1 0-1.469 1 1 0 0 1 1.437 0L7.031 9l4.25-4.438a1 1 0 0 1 1.406 0 1.094 1.094 0 0 1 0 1.47z" })] }));
});
CheckboxChecked.displayName = 'CheckboxChecked';
export default CheckboxChecked;
//# sourceMappingURL=CheckboxChecked.js.map